import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/utils/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'inline-flex h-12 items-center justify-center rounded-md bg-transparent',
            className
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-[0.9375rem] font-medium border-b-2 ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-primaryWeb data-[state=active]:border-primaryWeb data-[state=active]:shadow-sm',
            className
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

// #region Tabs account
const TabsTriggerAcc = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'h-12 rounded-tl rounded-tr inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-[0.9375rem] text-text-foreground2 bg-background-13 font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-background-3 data-[state=active]:bg-primaryWeb',
            className
        )}
        {...props}
    />
));
TabsTriggerAcc.displayName = TabsPrimitive.Trigger.displayName;
// #endregion

const TabsContent = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

// #region Tabs List Enduser
const TabsListEU = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'inline-flex h-fit items-center justify-center bg-transparent overflow-hidden',
            className
        )}
        {...props}
    />
));
TabsListEU.displayName = TabsPrimitive.List.displayName;
// #endregion Tabs List Enduser

// #region Tabs Trigger Enduser
const TabsTriggerEU = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-fs-mid14 leading-lh-mid14 font-bold border border-border-gray ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-customWhite data-[state=active]:bg-primaryWeb',
            'data-[state=inactive]:hoverable:hover:border-primaryWeb data-[state=inactive]:hoverable:hover:text-primaryWeb',
            className
        )}
        {...props}
    />
));
TabsTriggerEU.displayName = TabsPrimitive.Trigger.displayName;
// #endregion Tabs Trigger Enduser

// #region Tabs Content Enduser
const TabsContentEU = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'py-[40px] px-[min(36px,5vw)] border border-border-gray ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className
        )}
        {...props}
    />
));
TabsContentEU.displayName = TabsPrimitive.Content.displayName;
// #endregion Tabs Content Enduser

export {
    // general
    Tabs,
    TabsList,
    TabsTrigger,
    TabsTriggerAcc,
    TabsContent,
    // eu
    TabsListEU,
    TabsTriggerEU,
    TabsContentEU
};
